var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('avatar',{style:(_vm.cssVars),attrs:{"fullname":_vm.fullName,"size":_vm.size,"radius":_vm.radius,"image":_vm.image,"color":_vm.color},on:{"click":_vm.action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }